'use client'

import { Builder } from '@builder.io/react'

import { ButtonVariants } from '@src/components/Button/Button'
import { SKUSelectorDropdown } from '@src/components/SKUSelectorDropdown/SKUSelectorDropdown'
import { SKUSelectorDropdownDefaults } from '@src/components/SKUSelectorDropdown/SKUSelectorDropdown.defaults'

Builder.registerComponent(SKUSelectorDropdown, {
  name: 'SKUSelectorDropdown',
  inputs: [
    {
      name: 'previewAllItems',
      type: 'boolean',
      helperText:
        'Displays all options in the builder editor. Only builder content for each option can be edited by clicking. All other settings are configured below.',
      defaultValue: SKUSelectorDropdownDefaults.previewAllItems,
    },
    {
      name: 'options',
      type: 'list',
      subFields: [
        {
          name: 'sku',
          type: 'text',
          localized: true,
        },
        {
          name: 'label',
          type: 'text',
          localized: true,
        },
        {
          name: 'descriptor',
          type: 'text',
          localized: true,
        },
        {
          name: 'hasImage',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'image',
          type: 'object',
          showIf: 'options.get("hasImage") === true',
          subFields: [
            {
              name: 'src',
              type: 'text',
              localized: true,
            },
            {
              name: 'altText',
              type: 'text',
              localized: true,
            },
            {
              name: 'width',
              type: 'number',
              defaultValue: 16,
            },
            {
              name: 'height',
              type: 'number',
              defaultValue: 16,
            },
            {
              name: 'rightSpacing',
              type: 'number',
              defaultValue: 8,
            },
          ],
        },
        {
          name: 'contentTop',
          type: 'blocks',
          localized: true,
          hideFromUI: true,
        },
      ],
      defaultValue: SKUSelectorDropdownDefaults.options,
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'label',
          type: 'text',
          localized: true,
        },
        {
          name: 'variant',
          type: 'string',
          enum: ButtonVariants,
        },
        {
          name: 'redirectUrl',
          type: 'text',
          localized: true,
        },
      ],
      defaultValue: SKUSelectorDropdownDefaults.cta,
    },
  ],
})
